import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Services} from "../class/services";
import {environment} from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class HospitalService extends Services {

    name = 'hospital';

    /**
     *
     * @param http
     */
    constructor(http: HttpClient) {
        super(http);
    }

    campaing(): any {
        return this.http.get(`${environment.host}/campaign/list`);
    }
}
